<template>
    <div class="page-layout blank contacts-manage">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container d-flex justify-content-center">
                    <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                    <!-- <half-circle-spinner :animation-duration="1000" :size="60" color="#0475f3" /> -->
                </div>
            </div>
        </div>
        <div class="pb-5 mt-2" v-if="!ajaxCallinprogress">
            <div class="d-flex justify-content-start ">
                <span class="highlighted fs-15 pl-4 fw-500">Dashboard</span>
            </div>
            <div  class="w-100 pt-2">
                <div class="p-3 d-flex" style="border-top-left-radius: 10px;border-top-right-radius: 10px;background-color: #f0ddb7 !important;justify-content: space-between;">
                    <div class="d-flex align-items-center" style="position:relative">
                        <multiselect
                            v-model="ticket_by_temp"
                            class="newdigiticket-multiselect diginew-multiselect overflow-text custom-cred-fs  custom-dashboard mt-1 w-300px down-arrow ml-1"
                            :loading="ticket_by_temp_loading"
                            :options="ticket_by_temp_options"
                            :searchable="true"
                            :close-on-select="true"
                            name="ticket_by_temp"
                            track-by="id"
                            :show-labels="false"
                            @close="selectedTemplate"
                            :allow-empty="false"
                            open-direction="bottom"
                            @search-change="searchTemplate"
                            :multiple="false"
                            :options-limit="3000"
                            :max-height="200"
                            :clear-on-select="false"
                            label="name"
                            :internal-search="false"
                            :show-no-results="true"
                            :hide-selected="false"
                        >
                            <template slot="placeholder">
                                <span class="diginewhelp-multiselect text-black pl-3" style="opacity:none !important">All Templates</span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfTicketTemplate" />
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                        </multiselect>
                        <i class="icon icon-close text-black fs-16 fw-600 cancelIcon pos-x mt-1 mr-4 pointer" v-if="temp_id" @click="EraseTagsandtemps"></i>
                    </div>
                    <div class="d-flex">
                        <div class="mr-2">
                            <multiselect track-by="ticket_tags" v-if="ticket_by_temp != null && show_tag_field"
                                class="newdigiticket-multiselect diginew-multiselect dd-ht custom-chip custom-dashboard filter-multiple mt-1 ml-2 w-auto down-arrow" id="ajax"
                                placeholder="Select Tags" label="ticket_tags" :preselect-first="true"
                                :options="tag_options" v-model="entered_tag" @select="getAllTicketTempCount" @close="getAllTicketTempCount"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="false" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false" @remove="removeTags"
                                :loading="tag_loading" @search-change="getAllTagsAPI" :blockKeys="['Delete']"
                            >
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.ticket_tags }}</span>
                                    <span class="custom__remove pointer" @click="removeTags(option)">
                                    <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfTagOptions" />
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                            </multiselect>
                        </div>
                        <div>
                            <button class="btn btn-create btn-smm ml-2 mt-1"  @click="createTicket()" >
                                <i class="icon icon-plus-circle create-icon fs-20" ></i>
                                <span class="ml-1 text-success fs-14">New Ticket</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mx-0">
                    <div class="w-100 d-flex justify-content-center align-items-center" :class="!dashboardAjaxCallinprogress ? 'display-none' : ''">
                        <!-- <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" /> -->
                        <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12" style="background-color: #f0ddb7 !important;">
                        <div style="background-color: #ffffff !important;border: solid 0.5px #e6e6e6;margin-bottom:10px;border-radius:10px;" class="box-ticket" :class="dashboardAjaxCallinprogress ? 'display-none' : ''">
                            <h5 class="pl-6 pt-6 det-head">Ticket Details</h5>
                            <div class="d-flex flex-wrap m-2">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer totalTicket" @click="openParticularTicket('total_tickets')" >
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16" style="overflow: hidden;white-space: pre;">Total Tickets</div>
                                            <div>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/all-tickets-icon.svg" style="transform: scale(1.3)" width="40" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.total_tickets || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer fixedTicket" @click="openParticularTicket('fixed_tickets')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16">Fixed</div>
                                            <div>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/fixed-icon.svg" width="35" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.fixed.value || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer openedTicket" @click="openParticularTicket('opened_tickets')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16">Open</div>
                                            <div class="ticket-img-bg">
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/opened-ticket-logo.svg" width="100%" class="mt-1 tkt-st-icons" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.open.value || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer closedTicket" @click="openParticularTicket('closed_tickets')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16">Closed</div>
                                            <div>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/closed-icon.svg" style="transform: scale(1.3);" width="35" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.closed.value || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer inProgressTicket" @click="openParticularTicket('inprogress_tickets')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16">In Progress</div>
                                            <div>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/inprogress-icon.svg" width="35" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.inprogress.value || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="ticketSize pointer reopenedTicket" @click="openParticularTicket('reopened_tickets')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-16">Re-Open</div>
                                            <div>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/reopened-icon.svg" width="35" height="30">
                                            </div>
                                        </div>
                                        <div class="ticket_no text-center">{{overAllTicket.reopened.value || 0}}</div>
                                        <!-- <div class="gradient-line"></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12" style="background-color: #f0ddb7 !important;">
                        <fullscreen ref="dealdetails" @change="dataChange('dealdetails')" class="box-radius bg-white"  :class="dashboardAjaxCallinprogress ? 'display-none' : ''">
                            <div class="pie_chart_data mb-9" id="dealDetails">
                                <h5 class="pl-6 pt-6 text-left det-head">Tickets By Templates</h5>
                                <!-- <button type="button" class="pointer btn-fullscn bg-white icon-outline-css" @click="expandData('dealdetails'), dealDetails()">
                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/expand_logo.svg" alt="">
                                </button> -->
                                <div id="ticketsByProducts" style="height:430px"></div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
            </div>


            <div class="dashboardscmnew table_metain mt-3">
                <div class="d-flex justify-content-between align-items-center p-3 px-6">
                    <span class="text-center text-black font-weight-bold borderBottomNew fs-16">Recent Tickets</span>
                    <div class="d-flex align-items-center">
                        <span>
                            <button class="btn btn-secondary mr-2 ml-2 view-btn fs-14" style="width:100px !important;text-transform:capitalize" @click="viewAll()">
                                View All
                            </button>
                        </span>
                        <div class="d-flex align-items-center justify-content-center icon-div" style="width:100px !important">
                            <div class="d-flex justify-content-center align-items-center pointer icon-changes h-100" @click="changeView('grid')" :class="{'bg-secondary': !show_list}">
                                <i class="icon ri-layout-grid-fill" :class="!show_list ? 'text-white' : 'text-black'"></i>
                            </div>
                            <div class="d-flex justify-content-center align-items-center pointer icon-changes bord-left h-100" @click="changeView('list')" :class="{'bg-secondary': show_list}">
                                <i class="icon ri-list-check-line" :class="!show_list ? 'text-black' : 'text-white'"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-3" v-if="show_list">
                    <div class="table-content _closemb-3 p-4 background-table" v-if="show_list" >
                        <table class="table table-content-data table-content-custom table-responsive">
                            <thead>
                                <tr>
                                    <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('created_date')" class="cursor-th" >
                                            Ticket ID
                                            <span v-if="passed_key.key=='created_date' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                <i class=" ri-arrow-up-down-fill fw-400 text-black custom-sort-icon fs-13"></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                <i class=" ri-arrow-up-down-fill fw-400 text-black custom-sort-icon fs-13"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Author Name
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('subject')" class="cursor-th" >
                                            Subject
                                            <span v-if="passed_key.key=='subject' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400 text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400 text-black custom-sort-icon fs-13"></i>
                                            </span>
                                        </span>
                                    </th>
                                    
                                    <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('created_date')" class="cursor-th" >
                                            Creation Date
                                            <span v-if="passed_key.key=='created_date' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400 text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400  text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('assigned_to')" class="cursor-th" >
                                            Assigned To
                                            <span v-if="passed_key.key=='assigned_to' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400  text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400  text-black custom-sort-icon fs-13"></i>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('status')" class="cursor-th" >
                                            Ticket Status
                                            <span v-if="passed_key.key=='status' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400  text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                                <i class="ri-arrow-up-down-fill fw-400  text-black custom-sort-icon fs-13" ></i>
                                            </span>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="ajaxCallInProgress_all_tickets" class="text-center font-weight-bold">
                                    <td colspan="9">
                                        <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center" style="position:absolute;"/> -->
                                        <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                    </td>
                                </tr>
                                <tr v-if="!ajaxCallInProgress_all_tickets && allTickets.length == 0" class="text-center font-weight-bold ht-100px">
                                    <td colspan="9">No Tickets Found</td>
                                </tr>
                                <tr v-else v-for="(ticket, ticket_index) in allTickets" :key="ticket.ticket_id" class="pointer" @click="ticketDetails(ticket, ticket_index)">
                                   
                                    <td class="whiteSpace w-1 pointer fw-400">
                                        <span class="pointer fw-400">{{"#" +ticket.ticket_number}}</span>
                                    </td>
                                    <td class="whiteSpace w-1 pointer fw-400">
                                        {{ticket.created_by || '-'}}
                                    </td>
                                    <td class="whiteSpace w-1 pointer fw-400">
                                        <span class="caps " style="max-width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;">{{ticket.subject || '-'}}</span>
                                    </td>
                                    <td class="whiteSpace w-1 pointer fw-400">
                                        {{ticket.created_date}}
                                    </td>
                                    <td class="whiteSpace w-1 pointer fw-400">
                                        {{ticket.assigned_to || '-'}}
                                    </td>
                                    <td class="whiteSpace w-1 pointer">
                                        <button style="text-transform: capitalize; width: 110px !important;"
                                        class="btn btn-smm text-white btn-default btn-width btn-success-border-radius"
                                        :class="{'btn-open-status-newtheme':ticket.status == 'Open',
                                                'btn-assigned':ticket.status == 'Assigned',
                                                'btn-hex-gray38':ticket.status == 'Unassigned',
                                                'btn-grid-inprogress-newtheme':ticket.status == 'In progress',
                                                'btn-fixed-newtheme':ticket.status == 'Fixed',
                                                'btn-closed-newtheme':ticket.status == 'Closed',
                                                'btn-reopen-newtheme':ticket.status == 'Re-Open',
                                                'btn-moonlight-sage':ticket.status == 'Reject',
                                                'btn-schedule':ticket.status == 'Scheduled',
                                                'btn-discarded':ticket.status == 'Discard'}">
                                                {{ticket.status == 'In progress' ? 'InProgress' : ticket.status == 'Open' ? 'Open': ticket.status == 'Fixed' ? 'Fixed' : ticket.status == 'Re-Open' ? 'Reopen' : ticket.status == 'Closed' ? 'Closed': ticket.status == 'Discard' ? 'Discard' : ''}}
                                            <!-- {{ticket.status}} -->
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else class="px-3 pb-3">
                    <div class="px-3 pb-0" style="background-color: #fff !important;border-radius:5px;border:solid 0.5px #b2bec3;">
                        <div v-if="ajaxCallInProgress_all_tickets" class="text-center font-weight-bold">
                            <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center" style="position:absolute;"/> -->
                            <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                        </div>
                        <div class="row px-3 pb-3" v-else-if="!ajaxCallInProgress_all_tickets">
                            <div v-if="!ajaxCallInProgress_all_tickets && allTickets.length == 0" class="text-center font-weight-bold col-md-12">
                                <div class="text-center font-weight-bold ht-100px">
                                    <span>No Tickets Found</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 pointer mt-4" v-else v-for="(ticket,ticket_index) in allTickets" :key="ticket.ticket_id" @click="ticketDetails(ticket, ticket_index)">
                                <div class="d-flex p-4 ticket-box iconimage-position-relative">
                                    <div class="w-35">
                                        <div class="ticket-token text-center d-flex flex-column justify-content-between"
                                        :class="{'btn-open-status-newtheme':ticket.status == 'Open',
                                                'btn-assigned':ticket.status == 'Assigned',
                                                'btn-hex-gray38':ticket.status == 'Unassigned',
                                                'btn-grid-inprogress-newtheme':ticket.status == 'In progress',
                                                'btn-fixed-newtheme':ticket.status == 'Fixed',
                                                'btn-closed-newtheme':ticket.status == 'Closed',
                                                'btn-reopen-newtheme':ticket.status == 'Re-Open',
                                                'btn-moonlight-sage':ticket.status == 'Reject',
                                                'btn-schedule':ticket.status == 'Scheduled',
                                                'btn-discarded':ticket.status == 'Discard'}">
                                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/ticket-orange-icon-trans-bg.svg" width="47" class="margin-auto token-img" alt="">
                                            <span class="text-white pb-2">{{'#'+ticket.ticket_number}}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column justify-content-between w-70 pl-3">
                                        <div class="ticket-sub d-flex align-items-end mt-2">
                                            <div class=" fw-600 text-capitalize overflowing-text text-nowrap" :title="ticket.subject">{{ticket.subject}}</div>
                                            <el-dropdown>
                                                <sup>
                                                    <img src="/static/images/new-theme2024/error-warning-fill.svg" width="15" class="ml-1" alt="">
                                                </sup>
                                                <el-dropdown-menu slot="dropdown">
                                                    <div class="p-3">
                                                        <div class="d-flex pb-2" style="border-bottom:1px solid #ebebeb">
                                                            <div>
                                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/ticket-white-icon-trans-bg.svg" width="40" style="border-radius:100%"
                                                                :class="{'btn-open-status-newtheme-popup':ticket.status == 'Open',
                                                                'btn-assigned':ticket.status == 'Assigned',
                                                                'btn-hex-gray38':ticket.status == 'Unassigned',
                                                                'btn-grid-inprogress-newtheme-popup':ticket.status == 'In progress',
                                                                'btn-fixed-newtheme-popup':ticket.status == 'Fixed',
                                                                'btn-closed-newtheme-popup':ticket.status == 'Closed',
                                                                'btn-reopen-newtheme-popup':ticket.status == 'Re-Open',
                                                                'btn-moonlight-sage':ticket.status == 'Reject',
                                                                'btn-schedule':ticket.status == 'Scheduled',
                                                                'btn-discarded':ticket.status == 'Discard'}" alt="">
                                                            </div>
                                                            <div class="pl-3">
                                                                <span class="text-secondary fw-500">{{'#'+ticket.ticket_number}}</span><br>
                                                                <div class="fs-14 fw-500 text-capitalize overflowing-text text-nowrap" style="max-width:280px" :title="ticket.subject">{{ticket.subject}}</div>
                                                            </div>
                                                        </div>
                                                        <div class="pt-2 fs-12 text-capitalize">Assigned - {{ticket.assigned_to || '-'}}</div>
                                                        <div class="pt-2 fs-12 text-capitalize">Author - {{ticket.created_by}}</div>
                                                        <div class="pt-2 fs-12 text-capitalize">Product - {{ticket.product || '-'}}</div>
                                                        <div class="pt-2 fs-12">Date - {{ticket.created_date.slice(0,11)}}</div>
                                                        <div class="pt-2 fs-12 fw-600 ">Status -
                                                            <em :class="{'text-open-status-newtheme-popup':ticket.status == 'Open',
                                                                'btn-assigned':ticket.status == 'Assigned',
                                                                'btn-hex-gray38':ticket.status == 'Unassigned',
                                                                'text-grid-inprogress-newtheme-popup':ticket.status == 'In progress',
                                                                'text-fixed-newtheme-popup':ticket.status == 'Fixed',
                                                                'text-closed-newtheme-popup':ticket.status == 'Closed',
                                                                'text-reopen-newtheme-popup':ticket.status == 'Re-Open',
                                                                'btn-moonlight-sage':ticket.status == 'Reject',
                                                                'btn-schedule':ticket.status == 'Scheduled',
                                                                'btn-discarded':ticket.status == 'Discard'}">
                                                                {{ticket.status == 'In progress' ? 'InProgress' : ticket.status == 'Open' ? 'Open': ticket.status == 'Fixed' ? 'Fixed' : ticket.status == 'Re-Open' ? 'Reopen' : ticket.status == 'Closed' ? 'Closed': ticket.status == 'Discard' ? 'Discard' : ''}}
                                                            </em>
                                                        </div>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                        <span class=" ticket-assigned text-capitalize mt-1">Assigned - {{ticket.assigned_to || '-'}}</span>
                                        <div class="d-flex justify-content-between">
                                            <span class=" ticket-assigned text-capitalize mb-1">Product - {{ticket.product || '-'}}</span>
                                            <span class="ticket-assigned"
                                            :class="{'text-open-status-newtheme':ticket.status == 'Open',
                                                'btn-assigned':ticket.status == 'Assigned',
                                                'btn-hex-gray38':ticket.status == 'Unassigned',
                                                'text-grid-inprogress-newtheme':ticket.status == 'In progress',
                                                'text-fixed-newtheme':ticket.status == 'Fixed',
                                                'text-closed-newtheme':ticket.status == 'Closed',
                                                'text-reopen-newtheme':ticket.status == 'Re-Open',
                                                'btn-moonlight-sage':ticket.status == 'Reject',
                                                'btn-schedule':ticket.status == 'Scheduled',
                                                'text-discarded':ticket.status == 'Discard'}">
                                                <em class="fw-600">{{ticket.status == 'In progress' ? 'InProgress' : ticket.status == 'Open' ? 'Open': ticket.status == 'Fixed' ? 'Fixed' : ticket.status == 'Re-Open' ? 'Reopen' : ticket.status == 'Closed' ? 'Closed': ticket.status == 'Discard' ? 'Discard' :  ''}}</em>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end pb-3 pr-3" v-if="total > 0">
                    <multiselect class="diginew-multiselect fw-500 dd-ht multiple-select-arrow-hide"
                        :options="pageLimit" :close-on-select="true" v-model.number="limit"
                        @search-change="getAllTicketAPI" :allow-empty="false"
                        open-direction="top" :show-labels="false" placeholder=""
                        style="width: 4.3em !important;padding-right: 10px!important;"></multiselect>
                    <img src="/static/images/new-theme2024/arrow-down-s-line.svg"
                        style="margin-left: -35px; z-index: 10">
                    <span class="page-info pr-2 pl-6 fw-500 fs-14 text-black"
                        style="height: 2.4rem;line-height: 2.4rem;">Per page</span>
                    <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <!-- <i class="icon-chevron-double-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" :disabled="skip == 0" class="pagination-list-single mt-1 ml-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <!-- <i class="icon icon-chevron-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">

                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                    <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list-single mt-1 mr-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <!-- <i class="icon icon-chevron-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <!-- <i class="icon-chevron-double-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">

                        </el-tooltip>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import dashboard from '@/components/mixins/dashboard.js';
import convert from './mixins/convert';
import { EventBus } from './eventBus/nav-bar-event';
import { debounce } from 'lodash';

export default {
    mixins:[dashboard, convert],
    data(){
        return{
            ajaxCallinprogress:false,
            dashboardAjaxCallinprogress: false,
            display_type_options:['users', 'vendors', 'customers'],
            display_type:"",
            user_options:[],
            user_name:"",
            dash_filter_date:'',
            hideFilter:false,
            passed_key: {
                key: 'ticket_number',
                value: -1
            },
            skip:0,
            limit:10,
            total:0,
            search_key:'',
            count:0,
            temp_total:0,
            skip_temp: 0,
            ticketCategoryInterval: "products",
            ticket_by_product:[],
            ticket_products:[],
            ticket_by_department:[],
            ticket_department:[],
            overAllTicket:{
                closed:{
                    percentage: '0%',
                    value: 0.0
                },
                fixed:{
                    percentage: '0%',
                    value: 0.0
                },
                inprogress:{
                    percentage: '0%',
                    value: 0.0
                },
                open:{
                    percentage: '0%',
                    value: 0.0
                },
                reopened:{
                    percentage: '0%',
                    value: 0.0
                }
            },
            productCount:[],
            allTickets:[],
            ticketPriorityOption:[],
            highPriorityOption:'',
            ticketCreationTypeOptions:[],
            ticketByProductOption:[],
            ticketByDeptOptions:[],
            handelticketByDeptOptions:[],
            fullscreen: false,
            bubblescreen:false,
            creationscreen:false,
            screenHighPriroty:false,
            screenPriroty:false,
            user_selected:'',
            user_options:[],
            user_count:0,
            temp_user_options:[],
            user_loading:false,
            user_scrollable:false,
            user_visible:false,
            is_job_type: '',
            selected_display_type: '',
            start_date: '',
            end_date: '',
            user_selected_id: '',
            isVisible: false,
            scrollable: false,
            product_loading: false,
            search_product_key: '',
            product_count: 0,
            ticketByProductOptionFiltered: [
                {
                    name: "closed",
                    value: "0 %"
                },
                {
                    name: "fixed",
                    value: "0 %"
                },
                {
                    name: "in progress",
                    value: "0 %"
                },
                {
                    name: "open",
                    value: "0 %"
                },
                {
                    name: "re-open",
                    value: "0 %"
                },
            ],
            tag_options: [],
            tag_loading: false,
            tags_visible: false,
            tags_scrollable:false,
            tag_count:0,
            temp_tag_options:0,
            entered_tag: [],
            temp_id: '',
            ticket_by_temp: null,
            ticket_by_temp_loading: false,
            ticket_by_temp_options: [],

            is_temp_visible: false,
            temp_ticket_scrollable: false,
            temp_ticket_count: 0,
            show_list: true,
            temp_filterData: {
                created_tags: [],
                created_templates: []
            },
            temp_showfilterData:{
                created_tags: [],
                created_templates: []
            },
            show_tag_field: false,
            ajaxCallInProgress_all_tickets: false,
            pageLimit: [],
        }
    },
    methods:{
        expandData(value) {
            if(value == 'dealdetails'){
                this.$refs["dealdetails"].toggle();
                this.dealDetails();
            }
        },
        dealDetails(){
            var dealDetails = document.getElementById('dealDetails');
            dealDetails.classList.toggle('deals-details');
            dealDetails.classList.toggle('deal-details-expand');
            // var verticalScroll = document.getElementById('vertical-scroll');
            // verticalScroll.classList.toggle('vertical-scroll');
            // verticalScroll.classList.toggle('vertical-scroll-expand');
        },
        dataChange(value) {
            if(value == 'dealdetails'){
                this.dealdetails = value;
                this.dealDetails();
            }
        },
        changeView(view_type){
            if(view_type == 'list'){
                this.show_list = true
            } else if(view_type == 'grid'){
                this.show_list = false
            }
        },
        selectedTemplate(){
            if(this.ticket_by_temp.hasOwnProperty('id') && this.ticket_by_temp.id){
                this.temp_id = this.ticket_by_temp.id
                this.entered_tag = []
                this.tag_options = []
                this.tag_count = 0
                this.temp_tag_options = 0
                this.is_temp_visible = false
                this.tag_loading = false
                this.tags_scrollable = false
                this.getAllTicketTempCount();
                // setTimeout(() => {
                //     this.ticketByProductsAPI();
                // }, 500);
            }
        },
        EraseTagsandtemps(){
            this.temp_id = ''
            this.ticket_by_temp = null
            this.entered_tag = []
            this.tag_options = []
            this.temp_tag_options = 0
            this.tag_count = 0
            this.is_temp_visible = false
            this.tag_loading = false
            this.tags_scrollable = false
            this.getAllTicketTempCount();
        },
        async searchTemplateDebouncer(search_key){
            this.ticket_by_temp_options = []
            this.ticket_by_temp_loading = true;
            let params = {
                limit: 10,
                search_key: search_key,
                skip: 0
            };
            let response = await this.getAllProducts(params);
            this.ticket_by_temp_options = response.response.templates
            this.temp_ticket_count = response.response.templates.length
            this.ticket_by_temp_loading = false
        },
        async reachedEndOfTicketTemplate(reached){
            this.is_temp_visible = reached;
            if (reached) {
                if (this.temp_ticket_scrollable == false) {
                    this.ticket_by_temp_loading = true;
                    let params = {
                        limit: 10,
                        search_key: '',
                        skip: this.temp_ticket_count
                    };
                    let response = await this.getAllProducts(params);
                    let temp_ticket_temp = response.response.templates.length;
                    if (response.response.skip == this.temp_ticket_count) {
                        if (temp_ticket_temp > 0) {
                            let tempFiles = response.response.templates;
                            tempFiles.forEach(el => {
                                this.ticket_by_temp_options.push(el);
                            });
                            this.temp_ticket_count += response.response.templates.length;
                            this.ticket_by_temp_loading = false
                        } else {
                            this.temp_ticket_scrollable = true
                            this.ticket_by_temp_loading = false
                        }
                    }
                    this.ticket_by_temp_loading = false
                }
            }
        },
        limitTagId(count){
            return `+ ${count} more`
        },
        removeTags(option){
            this.entered_tag.forEach((el,index)=>{
                if(el.ticket_tags == option.ticket_tags){
                    this.entered_tag.splice(index,1)
                }
            })
        },
        async getAllTagsAPIDebouncer(search_key){
            try {
                this.tag_loading = true
                let params ={
                    "skip": 0,
                    "limit": 10,
                    "search_key": search_key,
                    "template_id": this.temp_id
                }
                let res = await this.getticketTagsByTemp(params)
                this.tag_options = res.response.ticket_tags
                this.tag_count = this.temp_tag_options
                this.tag_loading = false
                this.tags_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfTagOptions(reached){
            this.tags_visible = reached
            if (reached) {
                if (this.tags_scrollable == false) {
                    this.tag_loading = true
                    let params ={
                        "skip": this.tag_count,
                        "limit": 10,
                        "search_key": "",
                        "template_id": this.temp_id
                    }
                    let response = await this.getticketTagsByTemp(params)
                    this.temp_tag_options = response.response.ticket_tags.length;
                    if (response.response.skip == this.tag_count) {
                        if (this.temp_tag_options > 0) {
                            let tempFiles = response.response.ticket_tags;
                            tempFiles.forEach(el => {
                                if(el.tags !== ''){
                                    this.tag_options.push(el);
                                }
                            });
                            this.tag_count += response.response.ticket_tags.length;
                            this.tag_loading = false
                        } else {
                            this.tags_scrollable = true
                            this.tag_loading = false
                        }
                    }
                    this.tag_loading = false
                }
            }
        },
        ticketDetails(ticket, index){
            this.$router.push('/ticketDetails')
            let params = {
                skip: this.skip,
                index: index, 
                passed_key: this.passed_key,
                limit: this.limit
            }
            localStorage.setItem('getparticularTicket', JSON.stringify(params))
        },
        openParticularTicket(ticket_status){
            if(this.temp_id){
                if(!this.entered_tag.length){
                    this.temp_filterData = {
                        created_tags: [],
                        created_templates: [this.temp_id]
                    },
                    this.temp_showfilterData = {
                        created_tags: [],
                        created_templates: [this.ticket_by_temp]
                    }
                    let Dashboard_filter_data = {
                        filterData: this.temp_filterData,
                        showfilterData: this.temp_showfilterData
                    }
                    localStorage.setItem('storeDashboardFilter', JSON.stringify(Dashboard_filter_data))
                } else if(this.entered_tag.length){
                    let temp_entered_tag = []
                    this.entered_tag.forEach((el) => {
                        temp_entered_tag.push({
                            tags: el.ticket_tags
                        })
                    })
                    this.temp_filterData = {
                        created_tags: [...new Set(temp_entered_tag.map(x => x.tags))],
                        created_templates: [this.temp_id]
                    },
                    this.temp_showfilterData = {
                        created_tags: temp_entered_tag,
                        created_templates: [this.ticket_by_temp]
                    }
                    let Dashboard_filter_data = {
                        filterData: this.temp_filterData,
                        showfilterData: this.temp_showfilterData
                    }
                    localStorage.setItem('storeDashboardFilter', JSON.stringify(Dashboard_filter_data))
                }
            }
            switch(ticket_status){
                case 'total_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'overall'} })
                    break;
                case 'opened_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'opened'} })
                    break;
                case 'fixed_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'fixed'} })
                    break;
                case 'closed_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'closed'} })
                    break;
                case 'reopened_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'reopened'} })
                    break;
                case 'unassigned_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'unassigned'} })
                    break;
                case 'assigned_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'assigned'} })
                    break;
                case 'inprogress_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'inprogress'} })
                    break;
                case 'reject_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'reject'} })
                    break;
                case 'schedule_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'schedule'} })
                    break;
                case 'discarded_tickets':
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'Discard'} })
                    break;
            }
        },
        viewAll(){
            this.$router.push({
                name: 'TicketsList',
            })
        },
        toggleDepartment () {
            this.$refs['fullscreenDeparment'].toggle()
        },
        fullscreenDepartment (fullscreen) {
            this.fullscreen = fullscreen
        },
        toggleBubble () {
            this.$refs['fullscreenBubble'].toggle()
        },
        fullscreenChangeBubble (bubblescreen) {
            this.bubblescreen = bubblescreen
        },
        toggleCreation () {
            this.$refs['fullscreenCreation'].toggle()
        },
        fullscreenChangeCreation (creationscreen) {
            this.creationscreen = creationscreen
        },
        togglePriroty () {
            this.$refs['fullscreenPriroty'].toggle()
        },
        fullscreenChangePriroty (screenPriroty) {
            this.screenPriroty = screenPriroty
        },
        toggleHighPriroty () {
            this.$refs['fullscreenHighPriroty'].toggle()
        },
        fullscreenChangeHighPriroty (screenHighPriroty) {
            this.screenHighPriroty = screenHighPriroty
        },
        removeDept(option){
            this.ticket_by_department.forEach((el,index)=>{
                if(el._id == option._id){
                    this.ticket_by_department.splice(index,1)
                }
            })
        },
        removeProd(option) {
            this.ticket_by_product.forEach((el,index)=>{
                if(el.id == option.id){
                    this.ticket_by_product.splice(index,1)
                    setTimeout(() => {
                        this.getAllTicketTempCount();
                        // this.ticketByProductsAPI();
                    }, 500);
                }
            })
        },
        limitProduct(count){
            return `+ ${count} more`
        },
        limitDepart(count){
            return `+ ${count} more`
        },
        createTicket(){
            let ticket ={
                ticket_id:'',
                ticket_number:''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        showFilter(){
            this.hideFilter = !this.hideFilter;
        },
        closeFilters(){
            this.hideFilter = false
        },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getAllTicketAPI()
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.allTickets = []
            this.getAllTicketAPI()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getAllTicketAPI();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getAllTicketAPI();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getAllTicketAPI();
        },
        apply(){
            let params = {
            }
            if(this.dash_filter_date){
                params['dash_filter_date'] = this.convertDate(this.dash_filter_date)
            }
            this.$emit('appliedFilter',params)
        },
        clearFilter(){
            this.dash_filter_date = '';
            this.user_selected = '';
            this.display_type = '';
            this.end_date = '';
            this.user_selected_id = '';
            this.start_date = '';
            this.applyFilter();
        },
        update(dat) {
            this.user_selected_id = dat._id;
        },
        removeDisplayType(option) {
            this.temp_email.forEach((el,index)=>{
                if(el == option){
                    this.display_type_options.splice(index,1);
                }
            })
        },
        updateDisplayType(display_type) {
            if(display_type) {
                this.selected_display_type = display_type;
            }
            else {
                this.selected_display_type = '';
            }
        },
        convertFilter(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [day, mnth, date.getFullYear()].join("-");
        },
        updatedeliveryDate(){
            if(this.dash_filter_date){
                let value = this.convertFilter(this.dash_filter_date[0]);
                let value1 = this.convertFilter(this.dash_filter_date[1]);

                this.start_date = value;
                this.end_date = value1;
            }else{
                this.dash_filter_date = ''
                this.start_date = '';
                this.end_date = '';
            }
        },
        applyFilter() {
            this.getAllTicketAPI()
            // this.getAllTicketCount()
            this.getAllTicketTempCount()
            // this.ticketByDepartmentAPI()
            // this.ticketByProductsAPI()
            // this.ticketCreationTypeAPI()
            // this.highPriorityTicketsAPI()
            // this.ticketPriorityAPI()
            setTimeout(() => {
                this.hideFilter = false;
            }, 500);
        },
        async getAllUsers(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key: search_key ? search_key : this.search_key
                }
                let res = await this.getUserListFilter(params)
                this.user_options = res.response.users
                this.user_count = this.temp_user_options.length
                this.user_loading = false
                this.user_scrollable = false
                this.user_options.forEach((el,index)=>{
                    el['label'] = el.name
                    el['id'] = el.id
                })
            } catch (reason) {

            }
        },
        async reachedEndOfUsers(reached){
            this.user_visible = reached
            if (reached) {
                if (this.user_scrollable == false) {
                    this.user_loading = true
                    let params ={
                        skip:this.user_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserListFilter(params)
                    this.temp_user_options = response.response.users.length;
                    if (response.response.skip == this.user_count) {
                        if (this.temp_user_options > 0) {
                            let tempFiles = response.response.users;
                            tempFiles.forEach(el => {
                                this.user_options.push(el);
                            });
                            this.user_count += response.response.users.length;
                            this.user_loading = false
                        } else {
                            this.user_scrollable = true
                            this.user_loading = false
                        }
                        this.user_options.forEach((el,index)=>{
                            el['label'] = el.name
                            el['id'] = el.id
                        })
                    }
                    this.user_loading = false
                }
            }
        },
        async getAllTicketAPI(){
            try {
                this.ajaxCallInProgress_all_tickets = true
                this.allTickets = []
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                    sort_key: this.passed_key.key,
                    filters: {
                        sort_value: this.passed_key.value,
                    },
                    is_mobile:false,
                    status:this.status,
                    is_service_ticket:false
                }
                let res = await this.getAllTickets(params)
                this.is_job_type = res.response.job_type
                this.allTickets = res.response.all_tickets
                this.total = res.response.total_no_of_tickets
                this.ajaxCallInProgress_all_tickets = false
            } catch (reason) {

            }
        },
        async getAllTicketCount(){
            try {
                this.dashboardAjaxCallinprogress = true
                let params = {
                    display_type:this.display_type,
                    end_date:this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date:this.start_date
                }
                let res = await this.getTicketCount(params)
                this.overAllTicket = res.response
                this.dashboardAjaxCallinprogress = false
            } catch (reason) {

            }
        },
        async getAllTicketTempCount(){
            try{
                this.dashboardAjaxCallinprogress = true
                if(this.temp_id != ''){
                    let params = {
                        template: this.temp_id,
                        tags: [...new Set(this.entered_tag.map(x => x.ticket_tags))]
                    }
                    let res = await this.getticketCountByTemp(params)
                    this.overAllTicket = res.response
                } else {
                    let params = {}
                    let res = await this.getticketCountByTemp(params)
                    this.overAllTicket = res.response
                }
                this.ticketByProductOptionFiltered = [
                    {
                        name: "Closed",
                        value: "0 %"
                    },
                    {
                        name: "Fixed",
                        value: "0 %"
                    },
                    {
                        name: "In Progress",
                        value: "0 %"
                    },
                    {
                        name: "Open",
                        value: "0 %"
                    },
                    {
                        name: "Re-Open",
                        value: "0 %"
                    },
                ]
                for (var key in this.overAllTicket) {
                    if(key == 'closed'){
                        this.ticketByProductOptionFiltered[0].value =
                            typeof(this.overAllTicket['closed'].percentage) == 'string' && this.overAllTicket['closed'].percentage.includes('%') ? parseFloat(this.overAllTicket['closed'].percentage.split(" ")[0]) : parseFloat(this.overAllTicket['closed'].percentage)
                    } else if(key == 'fixed'){
                        this.ticketByProductOptionFiltered[1].value =
                            typeof(this.overAllTicket['fixed'].percentage) == 'string' && this.overAllTicket['fixed'].percentage.includes('%') ? parseFloat(this.overAllTicket['fixed'].percentage.split(" ")[0]) : parseFloat(this.overAllTicket['fixed'].percentage)
                    } else if(key == 'inprogress'){
                        this.ticketByProductOptionFiltered[2].value =
                            typeof(this.overAllTicket['inprogress'].percentage) == 'string' && this.overAllTicket['inprogress'].percentage.includes('%') ? parseFloat(this.overAllTicket['inprogress'].percentage.split(" ")[0]) : parseFloat(this.overAllTicket['inprogress'].percentage)
                    } else if(key == 'open'){
                        this.ticketByProductOptionFiltered[3].value =
                            typeof(this.overAllTicket['open'].percentage) == 'string' && this.overAllTicket['open'].percentage.includes('%') ? parseFloat(this.overAllTicket['open'].percentage.split(" ")[0]) : parseFloat(this.overAllTicket['open'].percentage)
                    } else if(key == 'reopened'){
                        this.ticketByProductOptionFiltered[4].value =
                        typeof(this.overAllTicket['reopened'].percentage) == 'string' && this.overAllTicket['reopened'].percentage.includes('%') ? parseFloat(this.overAllTicket['reopened'].percentage.split(" ")[0]) : parseFloat(this.overAllTicket['reopened'].percentage)
                    }
                }
                this.productTickets()
                this.dashboardAjaxCallinprogress = false
            } catch(error){
            }
        },
        productTickets(){
            let vuethis = this
            this.show_tag_field = !vuethis.ticketByProductOptionFiltered.every(x => x.value == 0)
            if(vuethis.ticketByProductOptionFiltered.every(x => x.value == 0)){
                document.getElementById("ticketsByProducts").innerHTML = '<div class="d-flex justify-content-center align-items-center" style="height:95%; border: solid 0.5px #707070; border-radius: 5px; margin: 30px;"><h2 class="text-danger">No Data!</h2></div>'
            } else {
                am4core.ready(function() {
                // am4core.ready(() => {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end
                    var chart = am4core.create("ticketsByProducts", am4charts.PieChart);
                    if(chart.logo){
                        chart.logo.disabled = true
                    }
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                    chart.legend = new am4charts.Legend();

                    /* Create a separate container to put legend in */
                    // var legendContainer = am4core.create("legenddiv", am4core.Container);
                    // legendContainer.width = am4core.percent(100);
                    // legendContainer.height = am4core.percent(100);
                    // chart.legend.parent = legendContainer;
                    // chart.legend.layout = "horizontal";

                    chart.data = vuethis.ticketByProductOptionFiltered
                    var series = chart.series.push(new am4charts.PieSeries3D());
                    series.dataFields.value = "value";
                    series.dataFields.category = "name";


                    series.colors.list = [
                        // am4core.color("#8067dc"), //Closed
                        // am4core.color("#6771dc"), //Opened
                        // am4core.color("#4285fc"), //InProgress
                        // am4core.color("#6794dc"), //Reopened
                        // am4core.color("#67b7dc"), //Fixed

                        am4core.color("#FF9134"), //Closed
                        am4core.color("#27B88F"), //Fixed
                        am4core.color("#2E5EF5"), //InProgress
                        am4core.color("#FD7372"), //Opened
                        am4core.color("#E4A741"), //Reopened
                    ];

                    chart.scrollbarX = new am4core.Scrollbar();

                });
                // end am4core.ready()
            }
        },
        departmentTickets(){
            let vuethis = this
            am4core.ready(function() {

                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                var chart = am4core.create("ticketsByDept", am4charts.XYChart);

                // Add data
                chart.data = vuethis.ticketByDeptOptions

                // Create axes

                var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "name";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 0;
                // Create value axis
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                // Create series
                var lineSeries = chart.series.push(new am4charts.LineSeries());
                lineSeries.dataFields.valueY = "value";
                lineSeries.dataFields.categoryX = "name";
                // lineSeries.name = "Sales";
                lineSeries.strokeWidth = 1;
                lineSeries.stroke = am4core.color("#ffd21f");

                // Add simple bullet
                var bullet = lineSeries.bullets.push(new am4charts.Bullet());
                bullet.fill = am4core.color("#0088ff"); // tooltips grab fill from parent by default
                var circle = bullet.createChild(am4core.Circle);
                circle.radius = 4;
                circle.fill = am4core.color("#0088ff");
                circle.strokeWidth = 0;

            }); // end am4core.ready()
        },
        ticketsRepeat(){
            this.ajaxCallinprogress = true
            am4core.ready(function() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            var data = [
                { name: "SCM", value: 69,color: am4core.color("#1b85bb")},
                { name: "HRMS", value: 45,color: am4core.color("#348f50") },
                { name: "HMS", value: 23,color: am4core.color("#4e54fa")},
                { name: "CRM", value: 12,color: am4core.color("#7366cc")},
                { name: "Cloud", value: 33,color: am4core.color("#f86c72")},
                { value: 2, sets: [ "SCM", "HRMS" ],color: am4core.color("#1b85bb") },
                { value: 3, sets: [ "SCM", "CRM" ],color: am4core.color("#1b85bb") },
                { value: 2, sets: [ "SCM", "HMS" ],color: am4core.color("#1b85bb") },
                { value: 3, sets: [ "SCM", "Cloud" ],color: am4core.color("#1b85bb") },
            ];

            var chart = am4core.create("repeatTickets", am4plugins_venn.VennDiagram);
            var series = chart.series.push(new am4plugins_venn.VennSeries())

            series.dataFields.category = "name";
            series.dataFields.value = "value";
            series.dataFields.intersections = "sets";
            series.data = data;
            series.slices.template.propertyFields.fill = "color";
            series.slices.template.fillOpacity = 0.9;
            series.labels.template.text = "[bold][#fff]{category}[/]";
            series.slices.template.tooltipText = "[bold]{category}: [bold]{value}%[/]";

            // chart.legend = new am4charts.Legend();
            // chart.legend.marginTop = 40;


            }); // end am4core.ready()
            this.ajaxCallinprogress = false
        },
        ticketsCreation(){
            let vuethis = this
            am4core.ready(function() {

                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end



                // Create chart instance
                var chart = am4core.create("creationTickets", am4charts.RadarChart);

                // Add data
                chart.data = vuethis.ticketCreationTypeOptions

                // Make chart not full circle
                chart.startAngle = -90;
                chart.endAngle = 180;
                chart.innerRadius = am4core.percent(20);

                // Set number format
                chart.numberFormatter.numberFormat = "#.#'%'";

                // Create axes
                var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "name";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.grid.template.strokeOpacity = 0;
                categoryAxis.renderer.labels.template.horizontalCenter = "right";
                categoryAxis.renderer.labels.template.fontWeight = 500;
                categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
                return (target.dataItem.index >= 0) ? chart.colors.getIndex(target.dataItem.index) : fill;
                });
                categoryAxis.renderer.minGridDistance = 10;

                var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.strokeOpacity = 0;
                valueAxis.min = 0;
                valueAxis.max = 100;
                valueAxis.strictMinMax = true;

                // Create series
                var series1 = chart.series.push(new am4charts.RadarColumnSeries());
                series1.dataFields.valueX = "full";
                series1.dataFields.categoryY = "name";
                series1.clustered = false;
                series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
                series1.columns.template.fillOpacity = 0.08;
                series1.columns.template.cornerRadiusTopLeft = 20;
                series1.columns.template.strokeWidth = 0;
                series1.columns.template.radarColumn.cornerRadius = 20;

                var series2 = chart.series.push(new am4charts.RadarColumnSeries());
                series2.dataFields.valueX = "value";
                series2.dataFields.categoryY = "name";
                series2.clustered = false;
                series2.columns.template.strokeWidth = 0;
                series2.columns.template.tooltipText = "{name}: [bold]{value}[/]";
                series2.columns.template.radarColumn.cornerRadius = 20;

                series2.columns.template.adapter.add("fill", function(fill, target) {
                return chart.colors.getIndex(target.dataItem.index);
                });

                // Add cursor
                chart.cursor = new am4charts.RadarCursor();

            }); // end am4core.ready()
        },
        ticketPriority(){
            let vuethis = this
            am4core.ready(function() {

                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                var chart = am4core.create("priorityTicket", am4charts.PieChart3D);
                chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                chart.data = vuethis.ticketPriorityOption

                chart.innerRadius = am4core.percent(40);
                chart.depth = 60;

                chart.legend = new am4charts.Legend();

                var series = chart.series.push(new am4charts.PieSeries3D());
                series.dataFields.value = "value";
                series.dataFields.depthValue = "value";
                series.dataFields.category = "name";
                series.slices.template.cornerRadius = 5;
                series.colors.step = 32;

            }); // end am4core.ready()
        },
        ticketByProductsAPIOnClose(data) {
            if(data) {
                setTimeout(() => {
                    // this.ticketByProductsAPI();
                    this.getAllTicketTempCount()
                }, 500);
            }
        },
        async ticketByProductsAPI(){
            this.ticketByProductOptionFiltered = [
                {
                    name: "closed",
                    value: "0 %"
                },
                {
                    name: "fixed",
                    value: "0 %"
                },
                {
                    name: "in progress",
                    value: "0 %"
                },
                {
                    name: "open",
                    value: "0 %"
                },
                {
                    name: "re-open",
                    value: "0 %"
                },
            ]
            try {
                let params = {
                    display_type: this.display_type,
                    end_date: this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date: this.start_date,
                    // product:[...new Set(this.ticket_by_product.map(x =>x._id))],
                    template:[...new Set(this.ticket_by_product.map(x =>x.id))],
                }
                let res = await this.ticketByTemplates(params)
                res.response.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        // this.ticketByProductOption.push({name:key,value:myArray[key]})
                        // let ticketByProductOptionFil = {name:key,value:myArray[key]} this.ticketByProductOption
                        // for (var i = 0; i < ticketByProductOptionFil.length; i++) {
                            if(key == 'closed'){
                                this.ticketByProductOptionFiltered[0].value = +((typeof(this.ticketByProductOptionFiltered[0].value) == 'string' ? +(this.ticketByProductOptionFiltered[0].value.includes('%') ? this.ticketByProductOptionFiltered[0].value.split(" ")[0] : this.ticketByProductOptionFiltered[0].value) : this.ticketByProductOptionFiltered[0].value) + +myArray[key].split(" ")[0]).toFixed(2)
                            }
                            else if(key == 'fixed'){
                                this.ticketByProductOptionFiltered[1].value = +((typeof(this.ticketByProductOptionFiltered[1].value) == 'string' ? +(this.ticketByProductOptionFiltered[1].value.includes('%') ? this.ticketByProductOptionFiltered[1].value.split(" ")[0] : this.ticketByProductOptionFiltered[1].value) : this.ticketByProductOptionFiltered[1].value) + +myArray[key].split(" ")[0]).toFixed(2)
                            }
                            else if(key == 'inprogress'){
                                this.ticketByProductOptionFiltered[2].value = +((typeof(this.ticketByProductOptionFiltered[2].value) == 'string' ? +(this.ticketByProductOptionFiltered[2].value.includes('%') ? this.ticketByProductOptionFiltered[2].value.split(" ")[0] : this.ticketByProductOptionFiltered[2].value) : this.ticketByProductOptionFiltered[2].value) + +myArray[key].split(" ")[0]).toFixed(2)
                            }
                            else if(key == 'open'){
                                this.ticketByProductOptionFiltered[3].value = +((typeof(this.ticketByProductOptionFiltered[3].value) == 'string' ? +(this.ticketByProductOptionFiltered[3].value.includes('%') ? this.ticketByProductOptionFiltered[3].value.split(" ")[0] : this.ticketByProductOptionFiltered[3].value) : this.ticketByProductOptionFiltered[3].value) + +myArray[key].split(" ")[0]).toFixed(2)
                            }
                            else if(key == 'reopened'){
                                this.ticketByProductOptionFiltered[4].value = +((typeof(this.ticketByProductOptionFiltered[4].value) == 'string' ? +(this.ticketByProductOptionFiltered[4].value.includes('%') ? this.ticketByProductOptionFiltered[4].value.split(" ")[0] : this.ticketByProductOptionFiltered[4].value) : this.ticketByProductOptionFiltered[4].value) + +myArray[key].split(" ")[0]).toFixed(2)
                            }
                        // }
                    }
                })
                this.productTickets()
            } catch (reason) {
                // console.log(reason)
            }
        },
        async getProductsAPI(key){
            this.product_loading = true;
            this.search_product_key = key
            try {
                let params = {
                    limit:10,
                    search_key: key,
                    skip:0,
                }
                let res = await this.getAllProducts(params)
                this.ticket_products = res.response.templates

                this.product_count = res.response.templates.length;
                this.product_loading = false;
            } catch (reason) {

            }
        },
        async reachedEndOfProduct(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollable == false) {
                    this.product_loading = true;
                    let params = {
                        limit: 10,
                        search_key: this.search_product_key,
                        skip: this.product_count
                    };
                    let response = await this.getAllProducts(params);
                    let temp_ticket_products = response.response.templates.length;
                    if (response.response.skip == this.product_count) {
                        if (temp_ticket_products > 0) {
                            let tempFiles = response.response.templates;
                            tempFiles.forEach(el => {
                                this.ticket_products.push(el);
                            });
                            this.product_count += response.response.templates.length;
                            this.product_loading = false
                        } else {
                            this.scrollable = true
                            this.product_loading = false
                        }
                    }
                    this.product_loading = false
                }
            }
        },
        async ticketCreationTypeAPI(){
            try {
                this.dashboardAjaxCallinprogress = true
                let params = {
                    display_type: this.display_type,
                    end_date: this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date: this.start_date,
                }
                let res = await this.ticketCreationType(params)
                res.response.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        this.ticketCreationTypeOptions.push({name:key,value:myArray[key],full:100})
                    }
                })
                // this.ticketsCreation()
                this.dashboardAjaxCallinprogress = false
            } catch (reason) {
                // console.log(reason)
            }
        },
        async highPriorityTicketsAPI(){
            try {
                this.ajaxCallinprogress = true
                let params = {
                    display_type: this.display_type,
                    end_date: this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date: this.start_date,
                }
                let res = await this.highPriorityTickets(params)
                this.highPriorityOption = res.response
                this.ajaxCallinprogress = false
            } catch (reason) {
                // console.log(reason)
            }
        },
        async ticketPriorityAPI(){
            try {
                this.ajaxCallinprogress = true
                let params = {
                    display_type: this.display_type,
                    end_date: this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date: this.start_date,
                }
                let res = await this.dashTicketPriority(params)
                res.response.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        this.ticketPriorityOption.push({name:key,value:myArray[key]})
                    }
                })
                // this.ticketPriority()
                this.ajaxCallinprogress = false
            } catch (reason) {
                // console.log(reason)
            }
        },
        async ticketByDepartmentAPI(){
            try {
                this.ajaxCallinprogress = true
                let params = {
                    department:[...new Set(this.ticket_by_department.map(x =>x._id))],
                    display_type: this.display_type,
                    end_date: this.end_date,
                    name: this.user_selected_id ? [this.user_selected_id] : [],
                    start_date: this.start_date,
                }
                let res = await this.ticketByDepartment(params)
                this.handelticketByDeptOptions.push(res.response)
                this.handelticketByDeptOptions.forEach((myArray,index)=>{
                    for (var key in myArray) {
                        this.ticketByDeptOptions.push({name:key,value:myArray[key]})
                    }
                })
                this.departmentTickets()
                this.ajaxCallinprogress = false
            } catch (reason) {
                // console.log(reason)
            }
        },
        async getDepartmentsAPI(){
            try {
                let params = {
                    limit:5,
                    search_key:'',
                    skip:0
                }
                let res = await this.getDepartments(params)
                this.ticket_department = res.response.all_departments
            } catch (reason) {

            }
        }
    },
    components:{
        HalfCircleSpinner
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        searchTemplate(){
            return debounce(this.searchTemplateDebouncer, 500)
        },
        getAllTagsAPI(){
            return debounce(this.getAllTagsAPIDebouncer, 500)
        },
    },
    async beforeMount(){
        localStorage.clear()
    },
    async mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        if (this.$cookie.get("Token")) {
            this.getAllTicketAPI()
            // this.getAllTicketCount()
            this.getAllTicketTempCount()
            // this.ticketByDepartmentAPI()
            // this.ticketByProductsAPI()
            // this.ticketCreationTypeAPI()
            // this.highPriorityTicketsAPI()
            // this.ticketPriorityAPI()
            // this.ticketsRepeat()
        } else {
            this.$router.push("/login").catch((errr) => {
                this.$router.push("/login")
            });
        }
    },
    watch: {
        "ticket_by_product": function(val) {
            if(val) {
                this.ticket_by_product = val
                this.$forceUpdate();
            }
        },
        limit: function(){
            this.getAllTicketAPI();
        }
    },
    created(){
        // if (this.$cookie.get("Token")) {
        //     this.getAllTicketTempCount()
        // }
    }
}
</script>
<style scoped>
.custom-sort-icon{
    position:relative;
    top:1px
}
.w-50{
    width:50% !important;
}
.bg-white{
    background-color: #fff;
}
.ticketSize{
    font-size: 18px;
    font-weight: 600;
    padding: 12px;
    border-radius: 8px;
    color: #fff !important;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}
.ticketSizeNew{
    font-size: 18px;
    font-weight: 600;
    padding: 20px 8px;
    border-radius: 8px;
    color: #303031 !important;
    background: #fff;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}
.totalTicket{
    /* background: #00448b; */
    background: #004686;
}
.openedTicket{
    /* background: #d32f2f; */
    /* background: #eb1d1d; */
    background: #FD7372;
}
.fixedTicket{
    /* background: #388e3c; */
    /* background: #45aa43; */
    background: #27B88F;
}
.closedTicket{
    /* background: #f9a825; */
    /* background: #ff9134; */
    background: #FF9134;
}
.reopenedTicket{
    /* background: #7b1fa2; */
    background: #E4A741;
}
.unassignedTicket{
    background: #616161;
}
.assignedTicket{
    background: #18d3cb;
}
.inProgressTicket{
    /* background: #4285fc; */
    /* background: #4285fc; */
    background: #2E5EF5;
}
.rejectTicket{
    background: #7b7f97;
}
.scheduledTicket{
    background: #2eb4f2;
}
.product-dash{
    border-bottom: 10px solid #afb42b;
}
.customers-dash{
    border-bottom: 10px solid #8d6e63;
}
.vendors-dash{
    border-bottom: 10px solid #7b1fa2;
}
.dept-dash{
    border-bottom: 10px solid #0097a7;
}
.users-dash{
    border-bottom: 10px solid #fa5788;
}
.team-dash{
    border-bottom: 10px solid #f57c00;
}
.dashboardscmnew{
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    background-color: #f0ddb7 !important;
    border-radius: 8px;
}

.filterDashboard{
    padding: 11.5px 5.5px 8.5px 6px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    background-image: linear-gradient(to bottom, #00448b, #2070d3);
    max-width: 290px;
    width: 280px;
    border-radius: 10px;
    z-index: 9999;
    position: absolute;
    right: 200px;
    margin-top: 5px;
}
.priority_ticket{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    top: 40px;
}

.ticket-img-bg{
    /* background-color: #ffffff; */
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
}
.round-defult{
    border-radius: 50px;
    height: 10px;
    width: 10px;
    display: flex;
    padding: 10px;
    margin-right: 5px;
}
.round-high{
    background-color: #e74c3c;
    border-radius: 50px;
}
.round-medium{
    background-color: #f1c40f;
    border-radius: 50px;
}
.round-low{
    background-color: #2ecc71;
    border-radius: 50px;
}
._expand{
    position:relative;
    right:5px;
    top:6px;
    float:right;
    width:15px
}
.dropdown-tags{
    margin-bottom: 3px;
}
.dropdown-tags-text{
    overflow: hidden;
    display: inline-flex;
}
@media screen and (max-width: 768px) {
    .table_metain{
        margin-top: 15px;
    }
}
#legenddiv{
    height: 40px;
    width: 100%;
    position: relative;
    /* left: 80%; */
    /* bottom: 4%; */
    top:10%;
}
@media screen and (max-width:992px) {
    #legenddiv{
        top: 0%;
    }
}
.newdigiticket-multiselect {
    width: 250px;
}
.gradient-line{
    margin-top:5px;
    background-image: linear-gradient(to right, #abaaac 3%, var(--white) 98%);
    height:2px;
    width:100%;
}
.ticket_no{
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
    font-size: 35px !important;
}
.det-head{
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #130e0e;
  font-size: 16px;
}
.tkt-st-icons{
    height: 25px
}
.w-270px{
    width:270px !important;
}
.w-auto{
    width: auto !important;
    min-width:230px !important;
}
.pos-x{
    position: absolute;
    right: 20px;
    top: auto;
}
.background-table{
    background-color: #fff !important;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border-radius: 5px;

}
.table_metain .ticket-token{
    height: 110px;
    border-radius:6px;
}
.table_metain .icon-div{
    border-radius: 5px;
    width: 4em;
    height: 1.5em;
    border: 1px solid #206ad3;
    background-color: #f2f3f5;
}
.table_metain .icon-changes{
    width: 50%;
    /* border-left: 0.2px solid #cce3fc; */
}
.table_metain .bord-left{
    border-left: 0.2px solid #cce3fc;
}
.table_metain .view-btn{
    height: 35px !important;
    border-radius: 5px !important;
}
.table_metain .btn-danger-grid-new,
.btn-danger-grid-new-new{
    background-color: #fd8484 !important;
}
.text-danger-grid-new-new,
.table_metain .text-danger-grid-new{
    color: #fd8484 !important
}
.btn-grid-inprogress-new,
.table_metain .btn-grid-inprogress{
    background: #4285FC !important;
}
.text-grid-inprogress-new,
.table_metain .text-grid-inprogress{
    color: #4285FC !important;
}
.btn-success-grid-new-new,
.table_metain .btn-success-grid-new{
    background: #2ecc71 !important;
}
.text-success-grid-new-new,
.table_metain  .text-success-grid-new{
    color: #2ecc71 !important;
}
.bt-grid-orange-new,
.table_metain .bt-grid-orange{
    background: #f1c442 !important;
}
.text-grid-orange-new,
.table_metain .text-grid-orange{
    color: #f1c442 !important;
}
.btn-grid-blue-new-new,
.table_metain .btn-grid-blue-new{
    background: #7B1FA2 !important;
}
.text-grid-blue-new-new,
.table_metain .text-grid-blue-new{
    color: #7B1FA2 !important;
}
.table_metain .w-70{
    width:80% !important;
}
.w-35{
    width:35% !important;
}
.w-32{
    width:32% !important;
}
.table_metain .ticket-sub{
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #130e0e !important;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom:5px;
}
.table_metain .ticket-assigned{
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #130e0e;
}
.table_metain .ticket-box{
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #b2bec3;
}
.table_metain .token-img{
    margin: auto !important;
    background: #fff;
    border-radius: 100%;
}
.el-dropdown-menu{
    box-shadow: 0 0 3px 0 #93badd;
}
.el-dropdown-menu .fw-600{
    font-weight: 600
}
.ticketSize{
    border-radius: 5px !important;
}

/*  button/card color customizations  */


.btn-open-status-newtheme-popup,
.table_metain .btn-open-status-newtheme{
    background-image: linear-gradient(to bottom, #f2706b, #ef3c36);
}
.btn-grid-inprogress-newtheme-popup,
.table_metain .btn-grid-inprogress-newtheme{
    background-image: linear-gradient(to bottom, #0166d0, #00448b)!important;
}
 .btn-discarded{
    background-image: linear-gradient(to bottom, #9fc8f4, #3883d5)!important;
}
.btn-fixed-newtheme-popup,
.table_metain .btn-fixed-newtheme{
    background-image: linear-gradient(to bottom, #10c38c, #0e8356) !important;
}
.btn-closed-newtheme-popup,
.table_metain .btn-closed-newtheme{
    background-image: linear-gradient(to bottom, #ff9234, #c6610a) !important;
}
.btn-reopen-newtheme-popup,
.table_metain .btn-reopen-newtheme{
    background-image: linear-gradient(to bottom, #f7cb74, #e4a641) !important;
}
.btn-discarded{
    background: #cce3fc !important;
    color: #000 !important
}

/*  Text color customizations  */

.text-open-status-newtheme-popup,
.table_metain .text-open-status-newtheme{
    color: #e14842 !important;
}
.text-grid-inprogress-newtheme-popup,
.table_metain .text-grid-inprogress-newtheme{
    color: #2E5EF5 !important
}
.text-fixed-newtheme-popup,
.table_metain .text-fixed-newtheme{
    color: #27B88F !important;
}
.text-discarded{
    color: #3883d5 !important;
}
.text-closed-newtheme-popup,
.table_metain .text-closed-newtheme{
    color: #FF9134 !important;
}
.text-reopen-newtheme-popup,
.table_metain .text-reopen-newtheme{
    color: #E4A741 !important
}
.box-radius{
    border-radius: 7px;
}
.pie_chart_data{
    border: solid 0.5px #e6e6e6;
    /* margin-bottom:10px; */
    border-radius:10px;
    height:98%;
    position: relative;
}
.btn-fullscn{
    position:absolute;
    right: 20px;
    top: 10px;
}
.deals-details{
    border: 1px solid #005dae;
    border-radius: 6px;
    width: 100%;
    height: 364px;
    max-height: 100%;
}
.deal-details-expand{
    height: 100%;
    overflow: auto;
}
.display-none{
    display: none !important;
}
.ht-100px{
    height: 100px;
}
span.caps::first-letter{
    text-transform: uppercase !important;
}
.h-100{
    height: 100% !important
}
.bg-secondary{
    background-color: #00448b !important;
}
.btn-success{
    border: 1px solid #038b62;
    background-color: #fff;
}
.text-success{
    text-transform: capitalize;
    color: #038b62 !important;
}
@media screen and (max-width: 768px) {
    .box-ticket{
        height: 100%;
    }
}
@media screen and (min-width: 769px) {
    .box-ticket{
        height: 483px;
    }
}
</style>